import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=3c6cc7a8&scoped=true"
import script from "./Step5.vue?vue&type=script&lang=js"
export * from "./Step5.vue?vue&type=script&lang=js"
import style0 from "./Step5.vue?vue&type=style&index=0&id=3c6cc7a8&prod&scoped=true&lang=scss"
import style1 from "./Step5.vue?vue&type=style&index=1&id=3c6cc7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6cc7a8",
  null
  
)

export default component.exports